import clubsService from '../services/clubsService'
import isEmpty from 'lodash/isEmpty'

const state = {
  clubs: [],
  clubsCount: 0,
  clubsFilters: {},
  clubsSettings: {},
  clubsLoaded: false
}

const mutations = {
  setClubs (state, data) {
    if (data.replace) {
      state.clubs = data.items
    } else {
      state.clubs.push(...data.items)
    }
    state.clubsCount = data.totalCount
  },
  removeClubs (state) {
    state.clubs = []
  },
  filtersUpdate (state, data) {
    state.clubsFilters = data.data
  },
  saveClubsSetting (state, data) {
    state.clubsSettings = data
  },
  setClubsLoadedStatus (state, status) {
    state.clubsLoaded = status
  }
}

const getters = {
  citiesFilterValues (state) {
    if (!state.clubsFilters.cities) {
      return []
    }
    const values = state.clubsFilters.cities
    const result = []
    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      result.push({
        id: option,
        name: option
      })
    }
    return result
  },
  sportTypesFilterValues (state) {
    return state.clubsFilters.sportTypes || []
  },
  sportTypesFilterValuesObj (state) {
    if (!state.clubsFilters.sportTypes) {
      return null
    }
    const values = state.clubsFilters.sportTypes
    const result = {}
    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      result[option.id] = option.value.trim()
    }
    return result
  }
}

const actions = {
  getClubs ({ state, commit }, data) {
    return clubsService.getClubs(data)
      .then(response => {
        commit('setClubs', {
          items: response.data.items,
          totalCount: response.data.totalCount,
          replace: data.offset === 0
        })
      })
  },
  getClubsFilters ({ state, commit }) {
    if (!isEmpty(state.clubsFilters) || state.clubsFiltersLoading) {
      return
    }
    state.clubsFiltersLoading = true
    return clubsService.getFilters()
      .then(response => {
        commit('filtersUpdate', {
          data: response.data
        })
        state.clubsFiltersLoading = false
      })
      .catch(() => {
        state.clubsFiltersLoading = false
      })
  }
}

export const clubs = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
